module.exports = __webpack_public_path__ + "img/page_bg_motivateGrowth.5949318d.png";